import { useQuery } from "@apollo/client";

import { CHECK_BLOB_STORAGE_HAS_DEFAULT_INTEGRATION } from "./gql";

const useCheckBlobStorageHasDefaultIntegration = (skip: boolean) => {
  const { data, loading } = useQuery(CHECK_BLOB_STORAGE_HAS_DEFAULT_INTEGRATION, {
    fetchPolicy: "no-cache",
    skip,
  });

  return {
    hasDefaultIntegration: typeof data?.checkBlobStorageHasDefaultIntegration?.id !== "undefined",
    loading,
  };
};

export default useCheckBlobStorageHasDefaultIntegration;
